import { z } from 'zod';

export type ComplectationOptionsCreateForm = {
    abs?: string,
    all_round_camera?: string,
    auto_parking_system?: string,
    aux?: string,
    blind_spot_monitoring?: string,
    bluetooth?: string,
    central_locking?: string,
    climate?: string,
    collision_avoidance_system?: string,
    combination_skin?: string,
    conditioner?: string,
    cruise_control?: string,
    driver_knee_airbag?: string,
    driver_tracking_system?: string,
    ebd?: string,
    electric_driver_seat?: string,
    electric_passenger_seat?: string,
    emergency_brake_assist?: string,
    fog_lights?: string,
    front_airbags?: string,
    front_parking_sensors?: string,
    glonass?: string,
    hac?: string,
    headlight_washer?: string,
    headlights?: string,
    heated_seats?: string,
    heated_wheel?: string,
    hold_lane_assist?: string,
    immobilizer?: string,
    interiortype?: string,
    isofix?: string,
    leather_gearshift?: string,
    leather_wheel?: string,
    light_sensor?: string,
    memory_settings?: string,
    multifunction_steering_wheel?: string,
    native_navigation_system?: string,
    number_seats?: string,
    panoramic_roof?: string,
    part_folding_baskrest?: string,
    power_heated_mirrors?: string,
    power_tailgate?: string,
    power_windows?: string,
    rain_sensor?: string,
    rear_door_lock?: string,
    rear_parking_sensors?: string,
    rear_view_camera?: string,
    roof_rails?: string,
    running_lights?: string,
    safety_shutters?: string,
    seat_ventilation?: string,
    side_airbags?: string,
    signalling?: string,
    smart_key?: string,
    socket_12v?: string,
    socket_220v?: string,
    steering_wheel?: string,
    tcs?: string,
    tire_pressure_monitoring?: string,
    usb?: string,
    wheels_material?: string,
    wheels_size?: string,
};

export type ComplectationCreateForm = {
    model_id?: number,
    code: string,
    complectation_option: ComplectationOptionsCreateForm,
};

export type ComplectationOptionsCreateFormErrors = {
    abs?: string[],
    all_round_camera?: string[],
    auto_parking_system?: string[],
    aux?: string[],
    blind_spot_monitoring?: string[],
    bluetooth?: string[],
    central_locking?: string[],
    climate?: string[],
    collision_avoidance_system?: string[],
    combination_skin?: string[],
    conditioner?: string[],
    cruise_control?: string[],
    driver_knee_airbag?: string[],
    driver_tracking_system?: string[],
    ebd?: string[],
    electric_driver_seat?: string[],
    electric_passenger_seat?: string[],
    emergency_brake_assist?: string[],
    fog_lights?: string[],
    front_airbags?: string[],
    front_parking_sensors?: string[],
    glonass?: string[],
    hac?: string[],
    headlight_washer?: string[],
    headlights?: string[],
    heated_seats?: string[],
    heated_wheel?: string[],
    hold_lane_assist?: string[],
    immobilizer?: string[],
    interiortype?: string[],
    isofix?: string[],
    leather_gearshift?: string[],
    leather_wheel?: string[],
    light_sensor?: string[],
    memory_settings?: string[],
    multifunction_steering_wheel?: string[],
    native_navigation_system?: string[],
    number_seats?: string[],
    panoramic_roof?: string[],
    part_folding_baskrest?: string[],
    power_heated_mirrors?: string[],
    power_tailgate?: string[],
    power_windows?: string[],
    rain_sensor?: string[],
    rear_door_lock?: string[],
    rear_parking_sensors?: string[],
    rear_view_camera?: string[],
    roof_rails?: string[],
    running_lights?: string[],
    safety_shutters?: string[],
    seat_ventilation?: string[],
    side_airbags?: string[],
    signalling?: string[],
    smart_key?: string[],
    socket_12v?: string[],
    socket_220v?: string[],
    steering_wheel?: string[],
    tcs?: string[],
    tire_pressure_monitoring?: string[],
    usb?: string[],
    wheels_material?: string[],
    wheels_size?: string[],
};

export type ComplectationCreateFormErrors = {
    model_id?: string[],
    code?: string[],
    complectation_option: ComplectationOptionsCreateFormErrors,
};

export const ComplectationOptionsCreateFormErrorsSchema = z.object({
    abs: z.array(z.string()).optional(),
    all_round_camera: z.array(z.string()).optional(),
    auto_parking_system: z.array(z.string()).optional(),
    aux: z.array(z.string()).optional(),
    blind_spot_monitoring: z.array(z.string()).optional(),
    bluetooth: z.array(z.string()).optional(),
    central_locking: z.array(z.string()).optional(),
    climate: z.array(z.string()).optional(),
    collision_avoidance_system: z.array(z.string()).optional(),
    combination_skin: z.array(z.string()).optional(),
    conditioner: z.array(z.string()).optional(),
    cruise_control: z.array(z.string()).optional(),
    driver_knee_airbag: z.array(z.string()).optional(),
    driver_tracking_system: z.array(z.string()).optional(),
    ebd: z.array(z.string()).optional(),
    electric_driver_seat: z.array(z.string()).optional(),
    electric_passenger_seat: z.array(z.string()).optional(),
    emergency_brake_assist: z.array(z.string()).optional(),
    fog_lights: z.array(z.string()).optional(),
    front_airbags: z.array(z.string()).optional(),
    front_parking_sensors: z.array(z.string()).optional(),
    glonass: z.array(z.string()).optional(),
    hac: z.array(z.string()).optional(),
    headlight_washer: z.array(z.string()).optional(),
    headlights: z.array(z.string()).optional(),
    heated_seats: z.array(z.string()).optional(),
    heated_wheel: z.array(z.string()).optional(),
    hold_lane_assist: z.array(z.string()).optional(),
    immobilizer: z.array(z.string()).optional(),
    interiortype: z.array(z.string()).optional(),
    isofix: z.array(z.string()).optional(),
    leather_gearshift: z.array(z.string()).optional(),
    leather_wheel: z.array(z.string()).optional(),
    light_sensor: z.array(z.string()).optional(),
    memory_settings: z.array(z.string()).optional(),
    multifunction_steering_wheel: z.array(z.string()).optional(),
    native_navigation_system: z.array(z.string()).optional(),
    number_seats: z.array(z.string()).optional(),
    panoramic_roof: z.array(z.string()).optional(),
    part_folding_baskrest: z.array(z.string()).optional(),
    power_heated_mirrors: z.array(z.string()).optional(),
    power_tailgate: z.array(z.string()).optional(),
    power_windows: z.array(z.string()).optional(),
    rain_sensor: z.array(z.string()).optional(),
    rear_door_lock: z.array(z.string()).optional(),
    rear_parking_sensors: z.array(z.string()).optional(),
    rear_view_camera: z.array(z.string()).optional(),
    roof_rails: z.array(z.string()).optional(),
    running_lights: z.array(z.string()).optional(),
    safety_shutters: z.array(z.string()).optional(),
    seat_ventilation: z.array(z.string()).optional(),
    side_airbags: z.array(z.string()).optional(),
    signalling: z.array(z.string()).optional(),
    smart_key: z.array(z.string()).optional(),
    socket_12v: z.array(z.string()).optional(),
    socket_220v: z.array(z.string()).optional(),
    steering_wheel: z.array(z.string()).optional(),
    tcs: z.array(z.string()).optional(),
    tire_pressure_monitoring: z.array(z.string()).optional(),
    usb: z.array(z.string()).optional(),
    wheels_material: z.array(z.string()).optional(),
    wheels_size: z.array(z.string()).optional(),
});

export const ComplectationCreateFormErrorsSchema = z.object({
    model_id: z.array(z.string()).optional(),
    code: z.array(z.string()).optional(),
    complectation_option: ComplectationOptionsCreateFormErrorsSchema.optional(),
});
